import { AxiosPromise } from 'axios';

import {
  CreatePharmaceuticalCompanyDto,
  GetPharmaceuticalCompaniesParams,
  PaginatedResponse,
  PharmaceuticalCompany,
  PharmaceuticalCompanyDetail,
  PharmaceuticalCompanyLightItem,
  PharmaceuticalCompanyListItem,
  UpdatePharmaceuticalCompanyDto,
  UpdatePharmaceuticalCompanyResponse,
} from 'shared/api';
import { apiInstance } from 'shared/api/typicode/base';

const BASE_URL = '/pharmaceutical-company';

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem('token') ?? ''}`,
});

export const getPharmaceuticalCompaniesAll = async (
  params?: GetPharmaceuticalCompaniesParams,
): AxiosPromise<PaginatedResponse<PharmaceuticalCompanyListItem>> =>
  apiInstance.get(`${BASE_URL}/all`, { params, headers: authHeaders() });

export const getPharmaceuticalCompaniesLight = async (): AxiosPromise<PharmaceuticalCompanyLightItem[]> =>
  apiInstance.get(`${BASE_URL}`, { headers: authHeaders() });

export const getPharmaceuticalCompanyById = async (id: string): AxiosPromise<PharmaceuticalCompanyDetail> =>
  apiInstance.get(`${BASE_URL}/${id}`, { headers: authHeaders() });

export const postPharmaceuticalCompany = async (
  data: CreatePharmaceuticalCompanyDto,
): AxiosPromise<PharmaceuticalCompany> => apiInstance.post(`${BASE_URL}`, data, { headers: authHeaders() });

export const patchPharmaceuticalCompany = async (
  id: string,
  data: UpdatePharmaceuticalCompanyDto,
): AxiosPromise<UpdatePharmaceuticalCompanyResponse> =>
  apiInstance.patch(`${BASE_URL}/${id}`, data, { headers: authHeaders() });

export const deletePharmaceuticalCompanyById = async (id: string): AxiosPromise<void> =>
  apiInstance.delete(`${BASE_URL}/${id}`, { headers: authHeaders() });
